<app-modal-generico [modelo]="modalGenerico">
  <div class="p-5">
    <header class="text-center mb-3">
      <label class="h5">Pregunta formulada</label>
    </header>
    <div class="form-group">
      <button class="btn btn-outline-primary mr-3 opsize" (click)="agregarOperador('+')">+</button>
      <button class="btn btn-outline-primary mr-3 opsize" (click)="agregarOperador('-')">-</button>
      <button class="btn btn-outline-primary mr-3 opsize" (click)="agregarOperador('*')">*</button>
      <button class="btn btn-outline-primary mr-3 opsize" (click)="agregarOperador('/')">/</button>
      <button class="btn btn-outline-primary mr-3 opsize" (click)="agregarOperador('(')">(</button>
      <button class="btn btn-outline-primary opsize" (click)="agregarOperador(')')">)</button>
    </div>
    <mat-form-field class="{{isSyntaxisError ? 'chip-list syntaxis-error' : 'chip-list'}}">
      <mat-chip-list #chipList aria-label="Selección de pregunta">
        <mat-chip
          *ngFor="let pregunta of preguntaLista; let i=index;"
          class="{{ pregunta.isOperator ? 'operator' : 'num-values' }}"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(i)">
          <span [innerHTML]="pregunta.name"></span>
          <mat-icon class="remove-icon" matChipRemove *ngIf="removable">clear</mat-icon>
        </mat-chip>
        <input
          placeholder=""
          #preguntaFormuladaInput
          [formControl]="preguntaFormuladaCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let pregunta of preguntaListaFiltrada | async" [value]="pregunta">
          <span [innerHTML]="pregunta.name"></span>
        </mat-option>
      </mat-autocomplete>
      <div *ngIf="isSyntaxisError" class="text-danger pt-2">
        <mat-icon>info</mat-icon>
        Sintaxis incorrecta, vuelve a intentarlo para continuar con la formulación de la pregunta.
      </div>
      <div *ngIf="isValid" class="text-success pt-2">
        <mat-icon>check_circle</mat-icon>
        Sintaxis correcta.
      </div>
    </mat-form-field>
    <div class="form-row mt-5">
      <button (click)="dismiss()" class="btn btn-outline-primary border-0 ml-auto">
        Cancelar
      </button>
      <button (click)="isValid ? close() : validate()" class="btn btn-primary">{{ isValid ? "Guardar" : "Validar" }}</button>
    </div>
  </div>
</app-modal-generico>
